var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['download-as-excel',(_vm.ete.isLoadingData)? 'loading':'ready']},[(_vm.ete.isLoadingData)?_c('span',[_vm._v("Preparing Excel file...")]):_c('span',{on:{"click":_vm.exportToExcelClick}},[_vm._v("Download as Excel")])])}
var staticRenderFns = []

export { render, staticRenderFns }